/**
 * Storage keys for the ORGANIZATION account session (owner / admin signing in at
 * /account/sign-in against the internal realm).
 *
 * Deliberately a separate namespace from JMS_KEYS: the site also hosts a
 * candidate session (job seekers, /profile) issued by a different realm. Sharing
 * keys would let one sign-in silently evict the other.
 *
 * The device signature is intentionally NOT duplicated here — it identifies the
 * browser, not the session, and the backend binds it per realm. Both realms read
 * the same value via getDeviceSignature().
 */
export const ACCOUNT_KEYS = {
  accessToken: 'a2a-account-accessToken',
  refreshToken: 'a2a-account-refreshToken',
  context: 'a2a-account-context',
} as const;

export function clearAccountStorage(): void {
  try {
    Object.values(ACCOUNT_KEYS).forEach((key) => localStorage.removeItem(key));
  } catch {
    // noop — storage may be unavailable (private mode, disabled cookies)
  }
}
